import React from 'react';

import { Divider } from '@mui/material';

import { PageLayout } from 'src/components/common';
import { SxProp } from 'src/types/mui';

import {
  AppCrashSection,
  ButtonGroupSection,
  ButtonSection,
  CheckboxInputSection,
  ChipSection,
  ModalSection,
  NotificationSection,
  RadioInputSection,
  SelectInputSection,
  StepperSection,
  TextInputSection,
  TimelineItemsSection,
  TypographySection,
} from './components';

export const Persik: React.FC = () => {
  return (
    <PageLayout titleContent="🍑 Persik UI" paperSx={pageLayoutPaperSx}>
      <TypographySection />
      <Divider sx={dividerStyles} />

      <ButtonSection />
      <Divider sx={dividerStyles} />

      <ButtonGroupSection />
      <Divider sx={dividerStyles} />

      <TextInputSection />
      <Divider sx={dividerStyles} />

      <SelectInputSection />
      <Divider sx={dividerStyles} />

      <CheckboxInputSection />
      <Divider sx={dividerStyles} />

      <RadioInputSection />
      <Divider sx={dividerStyles} />

      <ChipSection />
      <Divider sx={dividerStyles} />

      <StepperSection />
      <Divider sx={dividerStyles} />

      <TimelineItemsSection />
      <Divider sx={dividerStyles} />

      <ModalSection />
      <Divider sx={dividerStyles} />

      <NotificationSection />
      <Divider sx={dividerStyles} />

      <AppCrashSection />
    </PageLayout>
  );
};

const pageLayoutPaperSx: SxProp = {
  marginTop: 5,
  paddingTop: 2.5,
  paddingBottom: 5,
  paddingX: 5,
};

const dividerStyles: SxProp = {
  my: 2,
};
